// ==================================================
// Extrae un parametro de la current url
// ==================================================   
const getURLParameter = (n, url) => {
  const path = url || location.search;
  return decodeURIComponent((new RegExp('[?|&]' + n + '=' + '([^&;]+?)(&|#|;|$)').exec(path) || [null, ''])[1].replace(/\+/g, '%20')) || null;
};

const getURLPath = (n) => {
  const index = n || 0;
  var pathArray = window.location.pathname.split('/').filter(e => e);
  return pathArray[index];
};

const getURLQueryString = () => {
  return window.location.search.replace("?", "");
};

module.exports = {
  getURLParameter,
  getURLPath,
  getURLQueryString
};


// WEBPACK FOOTER //
// ./Statics/scripts/common/helpers/urlHelpers.js